import { render, staticRenderFns } from "./BasePaginacao.vue?vue&type=template&id=336d10b6&scoped=true"
import script from "./BasePaginacao.vue?vue&type=script&lang=js"
export * from "./BasePaginacao.vue?vue&type=script&lang=js"
import style0 from "./BasePaginacao.vue?vue&type=style&index=0&id=336d10b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d10b6",
  null
  
)

export default component.exports